<template>
<!-- eslint-disable -->
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
   viewBox="0 0 380.6 91.9" style="enable-background: new 0 0 380.6 91.9;" xml:space="preserve" fill="#3E3A93">
    <g>
      <path class="st0" style="fill: #3e3a93;" d="M276,86.3L286.8,63c0.1-0.2,0.1-0.4,0.1-0.6V2c0-1.1-0.9-2-2-2H252c-0.6,0-1.2,0.4-1.4,1l-5.7,13.8
          c-0.4,1,0.3,2.1,1.4,2.1h20c1.1,0,2,0.9,2,2v43.4c0,5.6-3.8,11.2-10.8,11.8c-6.8,0.5-13.9-4.5-18.1-8.1l0,0
          c-0.7-0.8-2.1-0.6-2.5,0.4l-5.8,12.2c-0.3,0.5-0.2,1.2,0.2,1.6l0.2,0.2c8.6,7.5,14.5,11.4,26.1,11.4c7.7,0,12.7-1.7,17.9-5
          C275.7,86.8,275.9,86.5,276,86.3z"/>
      <path class="st0" style="fill: #3e3a93;" d="M64.1,15.7l4.9-12.9C69.6,1.4,68.6,0,67.2,0H8.6C7.8,0,7.1,0.5,6.8,1.3L0.1,17.7c0,0-0.1,0.4-0.1,0.6l0,70.7
          c0,2.1,0.9,3,2,3h15.5c1.1,0,2-0.9,2-2V56.7c0-1.1,0.9-2,2-2h25.8c0.8,0,1.6-0.5,1.9-1.3l5.2-12.8c0.5-1.3-0.4-2.7-1.9-2.7H21.5
          c-1.1,0-2-0.9-2-2V18.9c0-1.1,0.9-2,2-2h40.8C63.1,16.9,63.8,16.4,64.1,15.7z"/>
      <path class="st0" style="fill: #3e3a93;" d="M227.2,15.7l5.6-12.9c0.6-1.3-0.4-2.8-1.8-2.8h-54.7c-0.8,0-1.6,0.5-1.9,1.3L167.3,19
          c-0.1,0.2-0.1,0.5-0.1,0.7v70.2c0,1.1,0.9,2,2,2h40.2c0.8,0,1.5-0.5,1.9-1.2l5.3-12.9c0.5-1.3-0.4-2.8-1.9-2.8h-26.9
          c-1.1,0-2-0.9-2-2V56.2c0-1.1,0.9-2,2-2h22.7c0.8,0,1.5-0.5,1.8-1.2l5.3-12.8c0.5-1.3-0.4-2.8-1.8-2.8h-28c-1.1,0-2-0.9-2-2V18.9
          c0-1.1,0.9-2,2-2h37.7C226.1,16.9,226.8,16.5,227.2,15.7z"/>
      <path class="st0" style="fill: #3e3a93;" d="M149.7,85.9l-15.2-22.6c-0.7-1-0.3-2.3,0.7-2.9c10-5.5,15.5-15.4,15.5-28.5c0-20.3-13.7-32-37.5-32H84
          c-0.8,0-1.6,0.5-1.9,1.3l-5.6,15.2c-0.1,0.2-0.1,0.5-0.1,0.7v72.8c0,1.1,0.9,2,2,2h14.5c1.1,0,2-0.9,2-2V67.3c0-1.1,0.9-2,2-2h16.2
          c0.7,0,1.3,0,2,0c0.7,0,1.4,0.4,1.7,1l15,24.7c0.4,0.6,1,1,1.7,1H148c1.1,0,2-0.9,2-2V87C150,86.6,149.9,86.2,149.7,85.9z
           M113.1,48.4H96.9c-1.1,0-2-0.9-2-2V18.9c0-1.1,0.9-2,2-2h16.2c13.1,0,19.7,5.2,19.7,15.4C132.9,43,126.2,48.4,113.1,48.4z"/>
      <path class="st0" style="fill: #3e3a93;" d="M380.4,73.4l-32-72.2c-0.3-0.7-1-1.2-1.8-1.2h-0.2c0,0,0,0,0,0h-15c-0.8,0-1.5,0.5-1.8,1.2l-38.9,87.9
          c-0.6,1.3,0.4,2.8,1.8,2.8h15.1c0.8,0,1.5-0.5,1.8-1.2l7.4-17.5c0.3-0.7,1-1.2,1.8-1.2h39.7c0.7,0,1.2,0.3,1.6,0.9l7,17.1l0.4,0.9
          l0.3,0.6c0.2,0.3,0.3,0.4,0.5,0.5l0,0h0c0.2,0,0.4,0,0.7,0h3.4c0.8,0,1.5-0.5,1.8-1.2l6.3-15.6C380.7,74.6,380.7,74,380.4,73.4z
           M349.4,55.2h-22c-1.4,0-2.4-1.5-1.8-2.8l11-25.8c0.7-1.6,3-1.6,3.7,0l11,25.8C351.9,53.7,350.9,55.2,349.4,55.2z"/>
    </g>
  </svg>
<!-- eslint-enable -->
</template>

<script>
  export default {
    name: 'FrejaEid'
  }
</script>
